var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isZubut)?_c('img',{staticClass:"zubut",attrs:{"src":require("@/assets/img/zubut-blue.png")}}):_c('img',{staticClass:"mu",attrs:{"src":require("@/assets/img/mu-logo_357x574.png")}})}
var staticRenderFns = []

export { render, staticRenderFns }